"use client"

import { useEffect, useState } from "react"
import API from "../services/api"
import { io } from "socket.io-client"
import "./SpasClient.css"

const socket = io("https://server-deploy-aq8t.onrender.com")

const SpasClient = () => {
  const [spas, setSpas] = useState([])
  const [selectedSpa, setSelectedSpa] = useState(null)
  const [isLoaded, setIsLoaded] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [showModal, setShowModal] = useState(false)
  const [reservationData, setReservationData] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    from: "",
    room:null,
    to: new Date().toISOString().split("T")[0], // today's date
    people: null,
  })

  const handleReservationSubmit = async () => {
    try {
      const payload = {
        ...reservationData,
        service: "spa",
        serviceDetails: selectedSpa?.name || "",
        status: "pending",
      }

      await API.post("/reservations", payload)
      alert("Réservation créée avec succès !")
      setShowModal(false)
      setReservationData({
        name: "",
        email: "",
        phoneNumber: "",
        from: "",
        room:0,
        to: new Date().toISOString().split("T")[0],
        people: 1,
      })
    } catch (error) {
      console.error("Erreur de réservation:", error)
      alert("Erreur lors de la création de la réservation.")
    }
  }

  const fetchSpas = async () => {
    try {
      setIsLoading(true)
      const res = await API.get("/spas")
      setSpas(res.data)
      setIsLoaded(true)
    } catch (error) {
      console.error("Erreur chargement des spas:", error)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchSpas()

    // Force a re-render after a short delay to ensure visibility
    const timer = setTimeout(() => {
      setIsLoaded(true)
    }, 100)

    socket.on("spaCreated", (newSpa) => {
      setSpas((prev) => [...prev, newSpa])
    })

    socket.on("spaUpdated", (updatedSpa) => {
      setSpas((prev) => prev.map((s) => (s._id === updatedSpa._id ? updatedSpa : s)))
    })

    socket.on("spaDeleted", (deletedId) => {
      setSpas((prev) => prev.filter((s) => s._id !== deletedId))
    })

    return () => {
      socket.off("spaCreated")
      socket.off("spaUpdated")
      socket.off("spaDeleted")
      clearTimeout(timer)
    }
  }, [])

  return (
    <div className="hotel-app0">
      <header className="app-header">
        <a href="/SolutionHotel/Home" className="header-back-link">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M19 12H5M5 12L12 19M5 12L12 5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          Retour
        </a>
        <div className="logo-container">
          <img src="/SolutionHotel/images/logo2.png" alt="Hotel Logo" className="logo" />
        </div>
        <div></div> {/* Empty div for flex spacing */}
      </header>

      <main className="app-main">
        <div className="welcome-banner">
          <h1>
            <span>Spa</span> & Bien-être
          </h1>
          <p>Détendez-vous et ressourcez-vous dans notre espace bien-être luxueux</p>
        </div>

        <div className="content-container">
          {isLoading ? (
            <div className="loading-container">
              <div className="loading-spinner"></div>
              <p>Chargement des spas...</p>
            </div>
          ) : spas.length === 0 ? (
            <div className="empty-state">
              <div className="empty-icon">🔍</div>
              <h3>Aucun spa trouvé</h3>
              <p>Revenez bientôt pour découvrir nos espaces bien-être</p>
            </div>
          ) : selectedSpa ? (
            <div className="spa-detail-view">
              <button className="back-to-list" onClick={() => setSelectedSpa(null)}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M19 12H5M5 12L12 19M5 12L12 5"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                Retour à la liste
              </button>

              <div className="spa-detail-content">
                <div className="spa-detail-image-container">
                  <img
                    src={selectedSpa.image || "/placeholder.svg"}
                    alt={selectedSpa.name}
                    className="spa-detail-image"
                    onError={(e) => {
                      e.target.src = `/placeholder.svg?height=300&width=500&text=${selectedSpa.name}`
                    }}
                  />
                </div>

                <div className="spa-detail-info">
                  <h2 className="spa-detail-name">{selectedSpa.name}</h2>
                  <div className="spa-detail-description">
                    <p>{selectedSpa.description || "Pas de description disponible."}</p>
                  </div>

                  <div className="spa-features">
                    {selectedSpa.features && selectedSpa.features.length > 0 ? (
                      selectedSpa.features.map((feature, index) => (
                        <div key={index} className="spa-feature-item">
                          <span className="feature-icon">✓</span>
                          <span>{feature}</span>
                        </div>
                      ))
                    ) : (
                      <>
                        <div className="spa-feature-item">
                          <span className="feature-icon">✓</span>
                          <span>Massages relaxants</span>
                        </div>
                        <div className="spa-feature-item">
                          <span className="feature-icon">✓</span>
                          <span>Soins du corps</span>
                        </div>
                        <div className="spa-feature-item">
                          <span className="feature-icon">✓</span>
                          <span>Aromathérapie</span>
                        </div>
                      </>
                    )}
                  </div>

                  <div className="spa-detail-cta">
                    <button className="reserve-button" onClick={() => setShowModal(true)}>
                      Réserver une séance
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className={`content-grid ${isLoaded ? "loaded" : ""}`}>
              {spas.map((spa, index) => (
                <div
                  key={spa._id}
                  className="content-item"
                  style={{ animationDelay: `${index * 0.05}s` }}
                  onClick={() => setSelectedSpa(spa)}
                >
                  <div className="content-item-image">
                    <img
                      src={spa.image || "/placeholder.svg"}
                      alt={spa.name}
                      onError={(e) => {
                        e.target.src = `/placeholder.svg?height=120&width=300&text=${spa.name}`
                      }}
                    />
                    <div className="content-item-overlay">
                      <span className="view-details">Voir détails</span>
                    </div>
                  </div>
                  <div className="content-item-content">
                    <h3>{spa.name}</h3>
                    <p>
                      {spa.description
                        ? spa.description.length > 100
                          ? spa.description.substring(0, 100) + "..."
                          : spa.description
                        : "Découvrez notre espace bien-être luxueux."}
                    </p>
                    <div className="content-item-arrow">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M12 4L20 12L12 20M4 12H20"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
        {showModal && (
          <div className="modal-backdrop">
            <div className="modal">
              <h2>Réserver une séance</h2>
              <input
                type="text"
                placeholder="Nom"
                value={reservationData.name}
                onChange={(e) => setReservationData({ ...reservationData, name: e.target.value })}
                required
              />
              <input
                type="email"
                placeholder="Email"
                value={reservationData.email}
                onChange={(e) => setReservationData({ ...reservationData, email: e.target.value })}
                required
              />
              <input
                type="tel"
                placeholder="Numéro de téléphone"
                value={reservationData.phoneNumber}
                onChange={(e) => setReservationData({ ...reservationData, phoneNumber: e.target.value })}
                required
              />
                     <input
                type="chambre"
                placeholder="Chambre"
                value={reservationData.room}
                onChange={(e) => setReservationData({ ...reservationData, room: e.target.value })}
                required
              />
              <input
                type="datetime-local"
                value={reservationData.from}
                onChange={(e) => setReservationData({ ...reservationData, from: e.target.value })}
                required
              />

              <input
                type="number"
                min="1"
                placeholder="Nombre de personnes"
                value={reservationData.people}
                onChange={(e) => setReservationData({ ...reservationData, people: e.target.value })}
                required
              />
              <div className="modal-actions">
                <button onClick={handleReservationSubmit}>✅ Réserver</button>
                <button onClick={() => setShowModal(false)}>❌ Annuler</button>
              </div>
            </div>
          </div>
        )}
      </main>

   
      <footer className="app-footer">
        <div className="footer-content">
          <div className="footer-section">
            <h4>Contact</h4>
            <p>+216 00 000 000</p>
            <p>info@hoteltunis.com</p>
          </div>
          <div className="footer-section">
            <h4>Adresse</h4>
            <p>Avenue de la Promenade</p>
            <p>Tunis, Tunisie</p>
          </div>
          <div className="footer-section">
            <h4>Réservations</h4>
            <p>+216 00 000 000</p>
            <p>reservations@hoteltunis.com</p>
          </div>
          <div className="footer-section">
            <h4>Wi-Fi</h4>
            <p>Réseau: HOTEL_GUEST</p>
            <p>Mot de passe: Disponible à la réception</p>
          </div>
          <div className="footer-section">
            <h4>Suivez-nous</h4>
            <div className="social-links">
              <a href="#" aria-label="Facebook">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
                </svg>
              </a>
              <a href="#" aria-label="Instagram">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
                </svg>
              </a>
              <a href="#" aria-label="Twitter">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z"></path>
                </svg>
              </a>
            </div>
          </div>
        </div>
        <div className="copyright">
          <p>
            © {new Date().getFullYear()} Hotel Tunis. Tous droits réservés.
            <br />
            Créé par{" "}
            <a href="https://www.itbafa.com" target="_blank" rel="noopener noreferrer">
              <img
                src="/SolutionHotel/images/itbafa_logo_white.png"
                alt="ITBAFA Logo"
                style={{ height: "20px", verticalAlign: "middle", marginLeft: "5px" }}
              />
            </a>
          </p>
        </div>
      </footer>
    </div>
  )
}

export default SpasClient
